export var prepareErrorsArray = function prepareErrorsArray(errorsById) {
  return Object.values(errorsById).flat();
};